/* eslint-disable react/prop-types */
import React from 'react';
import ComponentVideo from '../../component-video';
import type { GqlComponentVideo } from '../../../../content/types/content/component-video';
import { useDefaultFeatureFlags } from '../../../hooks/use-default-feature-flags';

interface ComponentKbVideoProps {
    entry: GqlComponentVideo;
}

const ComponentKbVideo: React.FC<ComponentKbVideoProps> = ({ entry }) => {
    const featureFlags = useDefaultFeatureFlags();
    const isVideoEnabled = featureFlags.isVideoEnabled ?? false;

    // Don't render video if feature gate is disabled or not found
    if (!isVideoEnabled) {
        return <></>;
    }

    return (
        <div className="kb-article-video">
            <ComponentVideo
                videoUrl={entry.videoUrl}
                title={entry.title}
                description={entry.description}
            />
        </div>
    );
};

export default ComponentKbVideo;
